import { unref } from 'vue'

export function personCustomFields(boardId, personId) {
  return ['custom-fields-values', { boardId: unref(boardId), personId: unref(personId) }]
}

export function uniqueCustomFieldsValues(boardId, uid) {
  return [
    'custom-fields-values-unique',
    {
      boardId: unref(boardId),
      uid: unref(uid)
    }
  ]
}

export function personData(boardId, personId) {
  return ['person-data', { boardId: unref(boardId), personId: unref(personId) }]
}

export function personCompensation(boardId, personId) {
  return ['compensation-data', { boardId: unref(boardId), personId: unref(personId) }]
}

export function orgChartSortValuesRoot() {
  return ['org-chart-sort-values']
}

export function orgChartSortValuesBoard(boardId) {
  return [...orgChartSortValuesRoot(), { boardId: unref(boardId) }]
}

export function orgChartSortValues({ boardId, column }) {
  return [
    ...orgChartSortValuesRoot(),
    {
      boardId: unref(boardId),
      column: unref(column)
    }
  ]
}

export function countSummaryRoot() {
  return ['counts-by-custom-field']
}

export function countSummaryBoard(boardId) {
  return [...countSummaryRoot(), { boardId: unref(boardId) }]
}

export function countSummary({ boardId, fields, filters, hierarchyVersion }) {
  return [
    ...countSummaryRoot(),
    {
      boardId: unref(boardId),
      fields: unref(fields),
      filters: unref(filters),
      hierarchyVersion: unref(hierarchyVersion)
    }
  ]
}

export function personPlanHistory(boardId, personId) {
  return ['person-plan-history', { boardId: unref(boardId), personId: unref(personId) }]
}

export function scenarioStatus(boardId, status) {
  return ['scenario-status', { boardId: unref(boardId), status: unref(status) }]
}

export function boardMeta(boardId, key) {
  return ['board-meta', { boardId: unref(boardId), key: unref(key) }]
}

export function dynamicFilters(boardId) {
  return ['dynamic-filters', { boardId: unref(boardId) }]
}

export function scenarioHistory(boardId, personId) {
  return ['scenario-history', { boardId: unref(boardId), personId: unref(personId) }]
}

export function scenarioHistoryPagination(boardId, personId, limit = 100) {
  return [
    'scenario-history-pagination',
    { boardId: unref(boardId), personId: unref(personId), limit: unref(limit) }
  ]
}

export function scenarioHistoryGroupDetail(boardId, personId, detailKey) {
  return [
    'scenario-history-group-detail',
    { boardId: unref(boardId), personId: unref(personId), detailKey: unref(detailKey) }
  ]
}
